export default {"src":"/kelp/_next/static/media/kernel_new.dd60aef1.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};